export default __webpack_public_path__ + "static/media/ds1.aca8692a.png";